"use client";

import React, { useEffect, useState } from "react";
import { MotionDiv, Variants } from "@/utils/clientMotion";
import ManualCard from "@/components/manual-card";
import Image from "next/image";
import { MagnifyingGlassPlusIcon, XMarkIcon } from "@heroicons/react/24/outline";

interface Stat {
  img: string;
  alt: string;
  count: string;
  title: string;
  client: string;
}

export default function RebottManualSection() {
  const [stats] = useState<Stat[]>([
    { img: "/manual-rebott/HowtoUseRebottRVM-Version-TH.webp", alt: "คู่มือการใช้งานเครื่องเวอร์ชั่นภาษาไทย",   count: "0", title: "คู่มือการใช้งานเครื่อง", client: "เวอร์ชั่นภาษาไทย" },
    { img: "/manual-rebott/HowtoUseRebottRVM-Version-EN.webp", alt: "คู่มือการใช้งานเครื่องเวอร์ชั่นภาษาอังกฤษ", count: "0", title: "How to use the machine", client: "English Version" },
    { img: "/manual-rebott/HowtoRedeemRewards.webp",           alt: "คู่มือแลกของรางวัล",                 count: "0", title: "คู่มือแลกของรางวัล",             client: "ภาษาไทย/English Version" },
    { img: "/manual-rebott/BottlesPassTheCriteria.webp",       alt: "คู่มือขวดที่ผ่านเกณฑ์เข้าตู้Rebott",      count: "0", title: "คู่มือขวดที่ผ่านเกณฑ์", client: "เข้าตู้ Rebott" },
  ]);


  // lightbox state
  const [lightboxSrc, setLightboxSrc] = useState<string | null>(null);
  const closeLightbox = () => setLightboxSrc(null);

  // ปิดด้วย ESC
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => (e.key === "Escape" ? closeLightbox() : null);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
 
  
  return (
    <section className="bg-white mt-[5.7rem] py-10">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 gap-8 my-12 mx-12 sm:grid-cols-2 md:grid-cols-4 md:gap-4 lg:px-8">
          {stats.map((stat, idx) => (
            <div key={idx} className="relative group rounded-[20px] overflow-hidden">
              <MotionDiv
                className="bg-[#eff6ff] rounded-[20px] pt-[2.7rem] pb-[1.7rem] px-3 lg:px-4 xl:px-4
                           flex flex-col items-center transition-transform"
                           whileHover={{ scale: 1.05 }}
                           whileTap  ={{ scale: 0.95 }}
                           onHoverStart={() => {}}
                           onHoverEnd={() => {}}
              >
                <ManualCard {...stat} />
              </MotionDiv>

              {/* Overlay + Zoom button */}
              <button
                type="button"
                aria-label={`ขยายภาพ: ${stat.alt}`}
                onClick={() => setLightboxSrc(stat.img)}
                className="absolute inset-0 flex items-center justify-center
                           bg-black/55 opacity-0 group-hover:opacity-100
                           transition-opacity duration-200 text-white"
              >
                <MagnifyingGlassPlusIcon className="w-12 h-12 drop-shadow" />
              </button>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox (Full-screen) */}
      {lightboxSrc && (
        <div
          role="dialog"
          aria-modal="true"
          className="fixed inset-0 z-[9999] bg-black/90"
          onClick={closeLightbox} // คลิกพื้นหลังเพื่อปิด
        >
          {/* ปุ่มปิด */}
          <button
            type="button"
            onClick={closeLightbox}
            aria-label="ปิดภาพ"
            className="absolute top-4 right-4 p-2 rounded-lg bg-white/10 hover:bg-white/20 text-white"
          >
            <XMarkIcon className="w-7 h-7" />
          </button>

          {/* ภาพแบบเต็มจอ (contain) */}
          <div className="absolute inset-0 flex items-center justify-center p-4">
            <div className="relative w-full h-full max-h-[90vh]">
              <Image
                src={lightboxSrc}
                alt="ภาพขยาย"
                fill
                className="object-contain select-none"
                priority
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
